import { render } from "./FilmsComponent.vue?vue&type=template&id=0ff57264&scoped=true"
import script from "./FilmsComponent.vue?vue&type=script&lang=js"
export * from "./FilmsComponent.vue?vue&type=script&lang=js"

import "./FilmsComponent.vue?vue&type=style&index=0&id=0ff57264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff57264"]])

export default __exports__